import React, { MutableRefObject, useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";
import { init } from "echarts";

import { reverse } from "lodash";
import Color from "@/tool/color";
import Empty from "@/component/empty";
import moWelfare from "../store/wealfare";
import moIndex from "../../store";

interface IProps {}
interface IState {}

const Human = (props: IProps, state: IState) => {
  const hummerRef = useRef<any>(null);
  let echartdom: any = null;
  const { KeyFestivalsDate, KeyFestivalsList } = moWelfare;
  const { isMock } = moIndex;

  const getHeightData = () => {
    const list: any = [];
    KeyFestivalsDate?.forEach((item: any) => {
      list.push(item.data[2].rate);
    });
    return list;
  };

  const getMiddleData = () => {
    const list: any = [];
    KeyFestivalsDate?.forEach((item: any) => {
      list.push(item.data[1].rate);
    });
    return list;
  };

  const getLowData = () => {
    const list: any = [];
    KeyFestivalsDate?.forEach((item: any) => {
      list.push(item.data[0].rate);
    });
    return list;
  };

  const colorList = [Color.primary, Color.two, Color.warning];

  const render = () => {
    if (echartdom) echartdom.dispose();
    echartdom = init(hummerRef.current);
    const option = {
      color: colorList,
      grid: {
        top: 40,
        right: 40,
        bottom: 60,
        left: 70,
      },
      tooltip: {
        show: true,
        trigger: "axis",
        axisPointer: {
          type: "shadow",
          shadowStyle: {
            color: Color.primaryColor(0.04),
          },
          // label: { show: true },
        },
        textStyle: {
          color: Color.blackColor(0.85),
        },
        formatter(params: any) {
          let htl = `<p  style="font-family: 'Roboto';font-weight:500; color:${Color.blackColor(
            1
          )};">
          ${params[0].name}</p>`;
          reverse(params)?.forEach((element: any, i: number) => {
            htl += `<p style="margin-top:10px;display:flex;
                         justify-content: space-between;align-items: center;">
                      <span
                        style="display:inline-block;
                        width:10px;height:10px;background:${
                          colorList[element.seriesIndex]
                        };
                        border-radius:50%;margin-right:5px">
                      </span>
                      <span style="font-size:12px">${element.seriesName}</span>
                      <span style="margin:0 15px"></span>
                      <span style="font-family: 'Roboto'">
                        ${Math.ceil(Number(element.value)).toLocaleString()}
                      </span>
                   </p>`;
          });
          return htl;
        },
      },
      legend: {
        type: "plain",
        bottom: 0,
        data: reverse(["75分位", "50分位", "25分位"]),
        textStyle: {
          fontFamily: "PingFang SC",
        },
      },
      xAxis: {
        type: "category",
        // boundaryGap: false,
        data: KeyFestivalsList,
        axisLine: {
          show: true,
          lineStyle: {
            color: Color.ccc,
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: true,
          color: Color.blackColor(0.85),
          fontFamily: "Roboto",
        },
      },
      yAxis: {
        type: "value",
        splitLine: {
          show: true,
          lineStyle: {
            color: Color.blackColor(0.1),
            width: 1,
            type: "dashed",
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: Color.ccc,
          },
        },
        axisTick: {
          show: true,
          lineStyle: {
            color: Color.ccc,
          },
        },
        axisLabel: {
          show: true,
          interval: "auto",
          color: Color.blackColor(0.5),
          fontFamily: "Roboto",
        },
      },
      series: [
        {
          name: "75分位",
          type: "scatter",
          data: getHeightData(),
          symbolSize: 20,
        },
        {
          name: "50分位",
          type: "scatter",
          data: getMiddleData(),
          symbolSize: 20,
        },
        {
          name: "25分位",
          type: "scatter",
          data: getLowData(),
          symbolSize: 20,
        },
      ],
    };
    echartdom.setOption(option);
  };

  useEffect(() => {
    if (hummerRef.current) {
      render();
    }
    return () => {};
  }, [KeyFestivalsDate]);

  useEffect(() => {
    window.addEventListener("resize", render);
    return () => {
      window.removeEventListener("resize", render);
    };
  });

  return KeyFestivalsDate.length > 0 ? (
    <div
      ref={hummerRef}
      style={{
        width: "100%",
        height: "350px",
        marginBottom: 30,
        backgroundImage: isMock
          ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
          : "",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
      }}
    />
  ) : (
    <Empty />
  );
};

export default observer(Human);
